import { render, staticRenderFns } from "./SourceOfFunds.vue?vue&type=template&id=27409d68&scoped=true"
import script from "./SourceOfFunds.vue?vue&type=script&lang=js"
export * from "./SourceOfFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27409d68",
  null
  
)

export default component.exports